<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Push Notifications</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Push Notifications</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="PushNotification">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'PushNotificationList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Title</label>
                    <input type="text" id="title" name="title"
                           v-bind:class="{'has-error' : errors.has('title')}"
                           v-validate="'required'"
                           v-model="value.title" class="form-control title"
                           placeholder="Title">
                    <div class="help text-danger" v-show="errors.has('title')">
                      {{ errors.first("title") }}
                    </div>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Body</label>
                    <textarea id="body" name="body"
                              v-model="value.body" class="form-control body"
                              placeholder="Body"
                              rows="3"></textarea>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Select users </label><br>
                    <el-select
                      v-model="value.user_ids"
                      multiple
                      filterable
                      remote
                      reserve-keyword
                      placeholder="Please enter a keyword"
                      :remote-method="userLoad"
                      :loading="user_loading"
                      style="width: 100%">
                      <el-option
                        v-for="item in user_options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <small class="form-text text-muted"><i class="fa fa-info-circle"></i>&nbsp;Start typing here to
                      search. </small>
                  </div>

                  <div class="col-md-12">
                    <h4 class="site-heading my-3"><span>Upload bulk students</span>
                      <button type="button" class="btn btn-sm" @click="downloadSampleUserFile">Download sample</button>
                    </h4>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="user_file"></label>
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="input-group">
                          <div class="custom-file">
                            <input type="file"
                                   name="user_file" class="custom-file-input" id="user_file"
                                   @change="select_file_user_file"
                                   accept=".xls,.xlsx,.csv">
                            <label class="custom-file-label" for="user_file">{{ value.user_file_name }}</label>
                          </div>
                        </div>
                        <a href="javascript:void(0)" @click="downloadUserFile(user_file_path)" class="link"
                                v-show="!_.isNull(user_file_path)">
                          {{ user_file_path }}
                        </a>
                      </div>
                    </div>
                    <div class="help text-danger" v-show="errors.has('user_file')">
                      {{ errors.first("user_file") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Product type</label>
                    <div class="form-group">
                      <el-select
                        v-model="value.product_type"
                        name="product_type"
                        placeholder="Select product type"
                        style="width: 100%"
                        :disabled="is_edit"
                      >
                        <el-option
                          v-for="item in [
                                { value: 'App\\Models\\Learning\\Course', label: 'Course' },
                                { value: 'App\\Models\\Learning\\BundlePackage', label: 'Bundle' },
                                { value: 'external', label: 'External' },
                              ]"
                          :key="item.value"
                          v-bind:class="{
                                'has-error': errors.has('product_type'),
                              }"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <div class="help text-danger" v-show="errors.has('product_type')">
                        {{ errors.first("product_type") }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-if="value.product_type === 'App\\Models\\Learning\\Course'">
                    <label class="control-label">Select course</label><br>
                    <el-select
                      v-model="value.notifyable_id"
                      filterable
                      remote
                      reserve-keyword
                      placeholder="Please enter a keyword"
                      :remote-method="courseLoad"
                      :loading="course_loading"
                      style="width: 100%">
                      <el-option
                        v-for="item in course_options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <small class="form-text text-muted"><i class="fa fa-info-circle"></i>&nbsp;Start typing here to
                      search. </small>
                  </div>
                  <div class="form-group" v-if="value.product_type === 'App\\Models\\Learning\\BundlePackage'">
                    <label class="control-label">Select bundle</label><br>
                    <el-select
                      v-model="value.notifyable_id"
                      filterable
                      remote
                      reserve-keyword
                      placeholder="Please enter a keyword"
                      :remote-method="bundleLoad"
                      :loading="bundle_loading"
                      style="width: 100%">
                      <el-option
                        v-for="item in bundle_options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <small class="form-text text-muted"><i class="fa fa-info-circle"></i>&nbsp;Start typing here to
                      search. </small>
                  </div>
                  <div class="form-group" v-if="value.product_type === 'external'">
                    <label class="control-label">External link</label>
                    <input type="text" id="external_link" name="external_link"
                           v-model="value.external_link" class="form-control external_link"
                           placeholder="External link">
                    <small class="form-text text-muted">
                      <i class="fa fa-info-circle"></i>
                      External link will be used while course field is empty otherwise, selected product url will be
                      used
                      as push notification url.
                    </small>
                  </div>
                  <div class="col-md-12">
                    <h4 class="site-heading my-3"><span>Thumbnail</span></h4>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="thumbnail"></label>
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="input-group">
                          <div class="custom-file">
                            <input type="file"
                                   accept="image/jpeg,image/png,image/jpg"
                                   name="thumbnail" class="custom-file-input" id="thumbnail"
                                   @change="select_file_thumbnail">
                            <label class="custom-file-label" for="thumbnail">{{ value.thumbnail_name }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-8">
                        <img
                          alt="preview image"
                          v-if="temp_thumbnail_preview"
                          v-bind:src="temp_thumbnail_preview"
                          width="100"
                          height="100"
                          class="img-circle"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Status</label>
                    <el-select
                      v-model="value.status"
                      name="status"
                      placeholder="Select status"
                      style="width: 100%" required
                    >
                      <el-option
                        v-for="item in [
                                { value: 'not_started', label: 'not_started' },
                                { value: 'processing', label: 'processing'},
                                { value: 'sent', label: 'sent' },
				                        { value: 'failed', label: 'failed' },
                              ]"
                        :key="item.value"
                        v-bind:class="{ 'has-error': errors.has('status') }"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('status')">
                      {{ errors.first("status") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import axios from "axios";
import {CommonAPI, LearningApi} from "@/services/api";

export default {
  name: "PushNotificationForm",
  metaInfo: {
    title: "Push Notifications | Dotlines"
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    user_file_path: '',
    params: {},
    user_loading: false,
    course_loading: false,
    bundle_loading: false,
    user_options: [],
    course_options: [],
    bundle_options: [],
    temp_thumbnail_preview: '',
    value: {
      user_file: '',
      user_file_name: 'Choose file',
      device_token_file: '',
      device_token_file_name: 'Choose file',
      thumbnail: '',
      thumbnail_name: 'Choose file',
      status: 'not_started'
    },
    pre: {}
  }),
  methods: {
    select_file_user_file: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
          this.value.user_file = reader.result;
          this.$set(this.value, 'user_file_name', event.target.files[0].name)
        };
      } catch (e) {}
    },

    select_file_device_token_file: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
          this.value.device_token_file = reader.result;
          this.$set(this.value, 'device_token_file_name', event.target.files[0].name)
        };
      } catch (e) {}
    },

    select_file_thumbnail: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
          this.value.thumbnail = reader.result;
          this.$set(this.value, 'thumbnail_name', event.target.files[0].name)
          this.temp_thumbnail_preview = reader.result;
        };
      } catch (e) {}
    },

    handleSubmission() {
      let _this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = "/push_notifications"
          let method = "POST"
          if (_this.is_edit) {
            api_url = "/push_notifications/" + _this.$route.params.id
            method = "PUT";
          }
          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({"name": "PushNotificationList"})
          }).catch((errors) => {
            _this.$toaster.error(errors.response.data.message)
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/push_notifications/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async userLoad(query) {
      if (query !== '') {
        this.user_loading = true
        await CommonAPI.getAllUsers(query).then(response => {
          this.user_options = response
        }).finally(() => {
          this.user_loading = false
        })
      } else {
        this.user_options = []
      }
    },

    async courseLoad(query) {
      if (query !== '') {
        this.course_loading = true
        await LearningApi.getCourseWithLimit10(query).then(response => {
          this.course_options = response.data
        }).finally(() => {
          this.course_loading = false
        })
      } else {
        this.course_options = []
      }
    },

    async bundleLoad(query) {
      if (query !== '') {
        this.bundle_loading = true
        await LearningApi.getBundleWithLimit10(query).then(response => {
          this.bundle_options = response.data
        }).finally(() => {
          this.bundle_loading = false
        })
      } else {
        this.bundle_options = []
      }
    },

    downloadSampleUserFile() {
      let samplePath = this.API_ROOT_URL + "/sample/sample_push_notify_student_list.xlsx"
      window.open(samplePath, '_blank')
    },

    downloadUserFile(filePath) {
      let samplePath = this.API_ROOT_URL + "/uploads/files/" + filePath
      window.open(samplePath, '_blank')
    },

    async initialize() {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data.push_notifications
          this.user_options = response.data.users

          this.value.user_ids = this.user_options.map(function (user) {
            return user.id
          })

          this.user_file_path = !_.isNull(this.value.user_file) ? this.value.user_file.split('/').pop() : null

          this.value.product_type = (_.isNull(this.value.notifyable_type)) ? 'external' : this.value.notifyable_type

          if (this.value.product_type === "App\\Models\\Learning\\BundlePackage") {
            this.bundle_options.push({
              id: this.value.notifyable.id,
              name: this.value.notifyable.bundle_title,
              product_type: 'bundle'
            })
            this.value.notifyable_id = this.value.notifyable.id
          } else if (this.value.product_type === "App\\Models\\Learning\\Course") {
            this.course_options.push({
              id: this.value.notifyable.id,
              name: this.value.notifyable.course_title,
              product_type: 'course'
            })
            this.value.notifyable_id = this.value.notifyable.id
          }
          this.temp_thumbnail_preview = this.value.thumbnail

        }).catch((error) => {
          console.log(error)
        })

        this.value.user_file = ''
        this.value.device_token_file = ''
        this.value.thumbnail = ''
      }
      this.is_loading = false
    },
  },
  mounted() {
    this.initialize()
  }
}
</script>

